import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "signInPage" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "bulletList" };
const _hoisted_4 = { class: "bulletRow" };
const _hoisted_5 = { class: "bulletIcon" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "bulletRow" };
const _hoisted_8 = { class: "bulletIcon" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "bulletRow" };
const _hoisted_11 = { class: "bulletIcon" };
const _hoisted_12 = ["src"];
const _hoisted_13 = {
    key: 0,
    class: "prefsCard"
};
const _hoisted_14 = { class: "prefsRow" };
const _hoisted_15 = { class: "prefsRow" };
const _hoisted_16 = { class: "notifActions" };
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import MGToggle from './elements/MGToggle.vue';
import { enableNotifications } from '../utils/native';
const WEB_COMPLETE = 3;
// One toggle for both balance notifications, as settings still has them separately
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInNotificationsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, savePreferences } = useCustomer();
        const dailyBalances = computed({
            get: () => !!(state.customer?.preferences?.dailyCurrentBalanceNotifications || state.customer?.preferences?.dailyCreditBalanceNotifications),
            set: (on) => {
                const prefs = state.customer?.preferences;
                if (!prefs)
                    return;
                prefs.dailyCurrentBalanceNotifications = on;
                prefs.dailyCreditBalanceNotifications = on;
            },
        });
        function onLoad() {
            getCustomer(() => {
                if (state.customer && state.customer.preferences == null) {
                    state.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false, quizNotifications: false };
                }
            });
        }
        function enable() {
            const prefs = state.customer?.preferences;
            // Only ask the host for permission if a notification is actually wanted. The flag is a
            // latch YouPage checks, so leaving it unset lets that prompt later instead.
            if (prefs?.dailyCurrentBalanceNotifications || prefs?.dailyCreditBalanceNotifications || prefs?.quizNotifications) {
                localStorage.setItem('notificationsRequested', 'true');
                enableNotifications();
            }
            router.push({ path: nextPath() });
        }
        function skip() {
            router.push({ path: nextPath() });
        }
        // signUpStageReached 3 is webComplete — signed up on the web but hasn't done the app's
        // first run yet (HomePage branches on the same value). Anything higher means they've been
        // through it already, so a returning member skips the details questions and the goals
        // survey and drops straight into the app.
        function nextPath() {
            const stage = state.customer?.signUpStageReached ?? 0;
            return stage > WEB_COMPLETE ? '/' : '/signin/details';
        }
        function savePrefs() {
            savePreferences();
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Notifications",
                    border: 0
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("img", {
                        class: "notifIllustration",
                        src: require('@/assets/signin/notification_animation.png'),
                        alt: ""
                    }, null, 8, _hoisted_2),
                    _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "notifTitle" }, "Stay on top of what matters", -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-card.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_6)
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Voucher offers you'll actually use", -1))
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-bill.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_9)
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Bill and renewal reminders", -1))
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("img", {
                                    src: require('@/assets/signin/bullet-goals.svg'),
                                    alt: ""
                                }, null, 8, _hoisted_12)
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Progress towards your goals", -1))
                        ])
                    ]),
                    (_unref(state).customer?.preferences)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", null, "Daily balances", -1)),
                                _createVNode(MGToggle, {
                                    modelValue: dailyBalances.value,
                                    "onUpdate:modelValue": [
                                        _cache[0] || (_cache[0] = ($event) => ((dailyBalances).value = $event)),
                                        savePrefs
                                    ]
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Quiz updates and reminders", -1)),
                                _createVNode(MGToggle, {
                                    modelValue: _unref(state).customer.preferences.quizNotifications,
                                    "onUpdate:modelValue": [
                                        _cache[1] || (_cache[1] = ($event) => ((_unref(state).customer.preferences.quizNotifications) = $event)),
                                        savePrefs
                                    ]
                                }, null, 8, ["modelValue"])
                            ]),
                            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "prefsNote" }, "Balance notifications are available for accounts you connect. You can change these settings at any time.", -1))
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                        _createVNode(MGButton, {
                            text: "Continue",
                            stacked: true,
                            arrow: true,
                            fullWidth: true,
                            onClick: enable
                        }),
                        _createVNode(MGButton, {
                            text: "Not now",
                            noCaps: true,
                            stacked: true,
                            fullWidth: false,
                            onClick: skip,
                            outline: false,
                            transparent: true,
                            arrow: true,
                            inlineArrow: true
                        })
                    ])
                ])
            ], 64));
        };
    }
});
